import { API } from "aws-amplify";

export default async function getTransactionPdf(data, posted) {
  return await API.get("transactions", `pdf/${posted ? "POSTED" : "PENDING"}`, {
    responseType: "blob",
    queryStringParameters: data,
  });
}
